class ContactOtpRequest{
  constractor(){
    this.userId=null;
    this.otp =null;
    this.type =null;
     this.isEmail=null;
    this.isPhone =null;
    this.contact =null;

    
  
   

  }}
  export default ContactOtpRequest; 
  